export default {
  namespaced: true,
  maintenance: {
    field_name: "Nombre del campo",
    field: "campo",
    move: "Mover",
    cancel: "Cancelar",
    move_above: "Mover arriba",
    move_below: "Mover abajo",
    moving: "Moviendo:",
    move_to_top: "Mover al inicio",
    move_to_bottom: "Mover al final",
    unknown_field: "Campo desconocido",
    confirm_delete_item: "¿Seguro que deseas eliminar el elemento?",
    visibility: "Visibilidad",
    conditional: "Condicionar",
    previous_question: "Pregunta (previa)...",
    select_placeholder: "Selecciona...",
    clear: "Limpiar",
    always_visible: "Sin condiciones: este campo siempre es visible.",
    auto_fill: "Autorrelleno",
    enable: "Activar",
    action_to_apply: "Acción a aplicar",
    copy_reference_value: "Copiar el valor del campo de referencia",
    apply_new_value: "Aplicar nuevo valor",
    copy_other_value: "Copiar valor de otro campo",
    overwrite_on_save: "Sobrescribir al guardar (overwrite)",
    value_to_apply: "Valor a aplicar (new_value)",
    enter_value: "Escribe el valor...",
    field_to_copy: "Campo a copiar",
    select_other_field: "Selecciona otro campo...",
    auto_fill_note: "Nota: se evaluará en tiempo de ejecución usando el operador seleccionado.",
    no_auto_fill: "Sin reglas: este campo no se autorrellena.",
    contains: "Contiene",
    empty: "Vacío",
    not_empty: "No vacío",
    search_text: "Texto a buscar...",
    value_placeholder: "Valor...",
    can_crop: "Permitir recortar",
    file_upload: {
      paste_image: "Pega una imagen aquí con Ctrl+V",
      images: "imágenes",
      minimum: "mínimo {min}",
      min_images_required: "Debes agregar al menos {min} imágenes.",
    },
    media_config: {
      min_required: "El mínimo es obligatorio",
      max_required: "El máximo es obligatorio",
      min_non_negative_integer: "El mínimo debe ser un entero positivo o cero",
      max_greater_than_zero: "El máximo debe ser mayor que cero",
      min_not_greater_than_max: "El mínimo no puede ser mayor que el máximo",
      max_not_less_than_min: "El máximo no puede ser menor que el mínimo",
    },
    title: "Mantenimiento",
    maintenance_crew: "Cuadrilla De Mantenimiento",
    maintenance_companies: "Empresas De Mantenimiento",
    maintenance_templates: "Plantillas De Mantenimiento",
    maintenance_forms: "Formularios De Mantenimiento",
    name: "Nombre",
    address: "Dirección",
    manager_name: "Nombre del gerente",
    manager_plate: "Teléfono del gerente",
    country_name: "País",
    site: "Sitio",
    document_number: "Número de documento",
    facility: "Instalación",
    select: "Select",
    multiple_select: "Select múltiple",
    camera: "Cámara",
    asset: "Activo",
    text_answer: "Respuesta de texto",
    format: "Formato",
    short_answer: "Respuesta corta",
    paragraph: "Párrafo",
    checkbox: "Casilla de verificación",
    date_time: "Fecha y hora",
    media: "Medios",
    slider: "Deslizador",
    min: "Mínimo",
    max: "Máximo",
    increment: "Incremento",
    annotation: "Anotación",
    signature: "Firma",
    location: "Ubicación",
    instruction: "Instrucción",
    field_types: "Tipos de campo",
    field_type_config: "Configuración del tipo de campo",
    preview: "Avance",
    date: "Fecha",
    time: "Hora",
    required: "Requerido",
    show_in_app: "Mostrar en la App",
    question: "Pregunta",
    type_response: "Tipo de respuesta",
    go_back: "Regresar",
    create_template: "Crear plantilla",
    update_template: "Actualizar plantilla",
    template_name: "Nombre de la plantilla",
    form_name: "Nombre del formulario",
    add_new_field: "Agregar nuevo campo",
    add_new_fileds: "Agregar nuevos campos",
    template:'Plantilla',
    addForm: 'Crear form',
    addTemplate: 'agregar template',
    serviceOrder: 'orden de servicio',
    add_new_fields: 'No se han añadido campos',
    choose_an_option: 'Selecciona una opción',
    select: 'Seleccionar',
    number: 'Número',
    number_config: {
      min: 'Mínimo',
      max: 'Máximo',
      help_text: 'Número (mínimo, máximo)',
      min_must_be_less_than_max: 'El mínimo debe ser menor que el máximo',
      max_must_be_greater_than_min: 'El máximo debe ser mayor que el mínimo',
      must_be_between: '{field} debe estar entre {min} y {max}.',
    },
    form_validations: {
      name: 'Define un nombre para este campo',
      type: 'Define un tipo para este campo',
    },
    messages: {
      created_success: 'Item Creado exitosamente',
      updated_success: 'Item Actualizado exitosamente'
    },
    crew: {
      description: 'Descripción',
      leader: 'Líder',
      users: 'Usuarios',
      company: 'Compañía'
    },
    status: {
      pending: 'Pendiente',
      in_review: 'En revisión',
      in_progress: 'En progreso',
      finished: 'Finalizado',
      canceled: 'Cancelado',
      latest_status: 'Último estado',
    },
    maintenance_form: "Formulario De Mantenimiento",
    export: "Exportar",
  },
};
